// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu__menuContainer--bkHgY","menuItem":"Menu__menuItem--AOTiZ","selected":"Menu__selected--Anc1B","promo":"Menu__promo--AOfqO","title":"Menu__title--xEu3w"};